import HeroSection from "./Hero-section/HeroSection.js";
import CommitmentSection from "./CommitmentSection/CommitSection.js";
import AppFeatures from "./features/AppFeatures.jsx";

function MainPage() {
  return (
    
    <div className="App">
      <HeroSection />
      <CommitmentSection />
      <AppFeatures/>
       
    </div>
  );
}

export default MainPage;
